import { useMemo } from 'react';

import { getActiveSite } from './sites';
import { getEcommerceGalleryByDataset } from '../content/ecommerceGallery';
import { getProjectsByDataset } from '../content/projectDatasets';
import { getSeoMetadata } from '../content/seoMetadata';

export default function useActivePortfolio(language) {
    return useMemo(() => {
        const site = getActiveSite();

        return {
            site,
            ecommerceGallery: getEcommerceGalleryByDataset(site.ecommerceDataset),
            projects: getProjectsByDataset(site.projectsDataset),
            seo: getSeoMetadata(site.seoProfile, language || site.defaultLanguage),
        };
    }, [language]);
}
